import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
    const location = useLocation();
    const token = localStorage.getItem("accessToken");

    if (!token) {
        return <Navigate to="/error/404" state={{ from: location }} replace />;
    }

    return children;
};

export default ProtectedRoute;
